export const constantsDictionary = {
  content: 'Content Section',
  profile: 'Profile',
  categories: 'Blog Categories',
  blogs: 'Blogs',
  blog: 'Blogs Page',
  seo: 'SEO',
  hrSection: 'HR Bo`limi',
  vacancies: 'Vakansiyalar',
  news: 'Yangiliklar',
  ourTeam: 'Bizning Jamoa',
}
